import canUseDom from '~/utils/can-use-dom'

export default canUseDom && /(iPhone|iPod|iPad)/i.test(navigator.platform)
